import { i18n } from "@/plugins/vuetify";
import { parseNumber } from "@/utils/NumberParser";
import { isValidInput } from "@/utils/Utils";
import { firestore } from "firebase";
import { DevicePowerUsageType } from "./DeviceAttribute";
import { RecordInfo } from "./RecordInfo";

const MAX_QR_CODE_LENGTH = 30;

export interface BaseDeviceInfo {
  manufacturer?: string | null;
  acquisitionDate?: firestore.Timestamp | null;
  qrCode?: string | null;

  availability: number;
  serialNumber: string;
  inventoryNumber: string;
  deviceName?: string;
  note?: string | null;

  branch?: string | null;
  homeLocation?: string | null;
  devicePowerUsageType?: DevicePowerUsageType | null;

  electricityMeterManufacturer?: string | null;
  electricityMeterNumber?: string | null;
  powerConsumptionPerHour?: number | null;

  lastCheck?: RecordInfo | null;
  nextCheck?: firestore.Timestamp | null;

  vehicleId?: string | null;
  deviceLastMoved?: RecordInfo | null; 
}

export function isQrCodeValid(qrCode: string | null) {
  if (!qrCode) {
    return true;
  }

  return qrCode.length <= MAX_QR_CODE_LENGTH && isValidInput(qrCode);
}

export function isManufacturerValid(manufacturer: string | null) {
  if (!manufacturer) {
    return true;
  }

  return isValidInput(manufacturer);
}

export function isSerialNumberValid(serialNumber: string) {
  if (serialNumber === "") {
    return true;
  }

  return isValidInput(serialNumber);
}

export function isElectricityMeterManufacturerValid(electricityMeterManufacturer: string | null) {
  if (!electricityMeterManufacturer) {
    return true;
  }

  return isValidInput(electricityMeterManufacturer);
}

export function isElectricityMeterNumberValid(electricityMeterNumber: string | null) {
  if (!electricityMeterNumber) {
    return true;
  }

  return isValidInput(electricityMeterNumber);
}

export function isNoteValid(note: string | null) {
  if (!note) {
    return true;
  }

  return isValidInput(note);
}

export function isInventoryNumberValid(inventoryNumber: string) {
  return isValidInput(inventoryNumber);
}

export function formatPowerConsumption(value: number): string {
  const formatter = new Intl.NumberFormat(i18n.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: false
  });

  return formatter.format(value);
}

export function parsePowerConsumption(numberString: string): number | null {
  const parsedPowerConsumption = parseNumber(numberString);
  
  if (!parsedPowerConsumption && parsedPowerConsumption !== 0) {
    return null;
  }

  return parsedPowerConsumption;
}

